<template>
<div class="main"> <!-- Edit -->
  <div class="content1"> <!-- frame 9 -->

    <div class="logo">  <!-- screenshot -->
      <img src="@/assets/images/logo/NudgPay.png" alt="Nudg Logo" class="logo" />

    </div>
    <div class="frame-33">  <!-- frame 33 -->
      <div class="frame-32">  <!-- frame 32 -->
        <p class="download-text">  <!-- Downlaod text -->
          Download The App <span class="text-24-7">24/7 </span>
        </p>

        <p class="des-text"> <!-- Downlaod text -->
          Your Taxi, Booked, Dispatched & Delivered upon request at any time. We work round the clock to ensure you get to your destination as quick as possible.
        </p>
      </div>
      <div class="frame-8">  <!-- frame 8 -->

        <div class="frame-5"> <!-- frame 5 -->
          <div class="frame-7"> <!-- frame 7 -->
            <div class="frame-6"> <!-- frame 6 -->
              <div class="frame-34"> <!-- frame 34 -->
                <p>
                  Journey details
                </p>
                <div class="frame-37"> <!-- frame 37 -->
                 <button @click="editButtonClick" class="blue-btn">
                  <span class="blue-btn-text"> Edit </span>
              </button>
                </div>
              </div>
              <div class="journey-details"> <!-- frame 6 -->
                <div class="journey-details-row"> <!-- frame 2 -->
                  <div class="journey-content"> <!-- frame 3 -->
                    <p class="journey-content-left">
                    Booking ID
                    </p>
                    <p class="journey-content-right-blue">
                      22344
                    </p>

                  </div>

                </div>

                <div class="journey-details-row"> <!-- frame 3 -->
                  <div class="journey-content"> <!-- frame 3 -->
                    <p class="journey-content-left">
                    Pick Up
                    </p>
                    <p class="journey-content-right-black">
                      1NGL Technology, carlton house.
                    </p>

                  </div>

                </div>


                <div class="journey-details-row"> <!-- frame 5 -->
                  <div class="journey-content"> <!-- frame 3 -->
                    <p class="journey-content-left">
                    Drop off
                    </p>
                    <p class="journey-content-right-black">
                      Nottingham, UK
                    </p>

                  </div>
                </div>
                <div class="journey-details-row"> <!-- frame 6 -->
                  <div class="journey-content"> <!-- frame 3 -->
                    <p class="journey-content-left">
                    Pick Up Due Time
                    </p>
                    <p class="journey-content-right-blue">
                      30th Oct 2024 6:44 pm
                    </p>

                  </div>
                </div>

              </div>


            </div>

          </div>
          <div class="price-and-buttons-section"> <!-- frame 39 -->
            <div class="price-section"> <!-- frame 35 -->
              <div class="price-section-textbox"> <!-- frame 5 -->
                <div class="price-section-text-div"> <!-- frame 3-->
                  <p>
                    Your fixed price
                  </p>
                </div>

              </div>
              <div class="price-section-value-div"><!-- frame 1 -->
                <p>£ 0</p>
              </div>
            </div>
            <div class="button-section"> <!-- frame 38 -->
              <button class="green-btn">
                  <span class="green-btn-text"> Pay Now</span>
              </button>
              <button class="green-btn">
                  <span class="green-btn-text"> Download </span>
              </button>
              <button class="blue-btn">
                  <span class="blue-btn-text"> Track </span>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
    <vs-popup class="modal-div" title="Edit booking" :active.sync="editBookingPopup">
       <div class="modal-div">
        <div class="modal-content-div">
          <form action="" method="post">
            <div class="form-div"><!-- 27155 -->
              <div class="form-area"> <!-- 27160 -->
                <div class="booking-status-area">
                  <div class="booking-status-text-area">
                    <div class="booking-status-text-div">
                      <p>Advanced Booking Unpaid</p>
                    </div>
                  </div>
                </div> <!-- 27153 -->
                <div class="edit-rows-area">
                  <div class="edit-row">
                    <div class="left-side">
                      <div class="left-side-content">
                        <label class="label">Date</label>
                         <datepicker format="dd/MM/yyyy" placeholder="01/01/2025" input-class="input-class cal-input" calendar-class="cal-cls"/>
                      </div>

                    </div>
                    <div class="right-side">
                      <div class="left-side-content">
                        <label class="label">Time</label>
                        <input type="time" class="time-input" placeholder="Lorum ipsum">
                      </div>
                    </div>
                  </div>

                  <div class="edit-row">
                    <div class="left-side">
                      <div class="left-side-content">
                        <label class="label">Pickup</label>
                        <input class="input-class" placeholder="Lorum ipsum">
                      </div>

                    </div>
                    <div class="right-side">
                      <div class="left-side-content">
                        <label class="label">DropOff</label>
                        <input class="input-class" placeholder="Lorum ipsum">
                      </div>
                    </div>
                  </div>

                  <div class="edit-row">
                    <div class="left-side">
                      <div class="left-side-content">
                        <label class="label">Vehicle type</label>
                        <input class="input-class" placeholder="Lorum ipsum">
                      </div>

                    </div>
                    <div class="right-side">
                      <div class="left-side-content">
                        <label class="label">Number of passengers</label>
                        <input class="input-class" placeholder="4">
                      </div>
                    </div>
                  </div>

                  <div class="edit-row">
                    <div class="left-side">
                      <div class="left-side-content">
                        <label class="label">Name</label>
                        <input class="input-class" placeholder="Name of customer">
                      </div>

                    </div>
                  </div>

                  <div class="edit-row">
                    <div class="left-side">
                      <div class="left-side-content">
                        <label class="label">Driver notes</label>
                        <textarea class="textarea-class" placeholder="Driver notes Driver notes Driver notes Driver notes Driver notes"/>
                      </div>
                    </div>
                  </div>
                </div><!-- 27159 -->
              </div>
            </div>
          </form>

        </div>

       </div>
      </vs-popup>
  </div>

</div>


</template>

<script>
import { MAIN_DOMAIN, WEB_SERVER_HOST } from "@/environment/index";
import Datepicker from 'vuejs-datepicker'

import Echo from "laravel-echo";
window.io = require("socket.io-client");

window.Echo = new Echo({
  broadcaster: "socket.io",
  host: WEB_SERVER_HOST,
  authEndpoint: "/broadcasting/auth",
});

import * as axios from "@/services/Axios";

import {
  _getBooking,
  _asCardPayment,
  _asCashPayment,
  _getReceipt
} from "@/services/Payment";


export default {
  components: {
    Datepicker
  },
  watch: {
    payForCharity(val) {
      if (val) {
        this.calculateAmountWithCharity();
        this.prepaycall(true);
      } else {
        this.amount = this.beforeCharityAmount;
        this.charityAmount = 0.0;
        this.prepaycall();
      }
    },
  },
  data() {
    return {
      editBookingPopup: false,

      current_company: null,
      charityDescriptionPopup: false,
      postUrl: null,
      reference: null,

      amount: 0,
      pickup: "",
      destination: "",
      bid: this.$route.params.bid,
      booking_found: false,
      is_archived: false,
      checkezp: false,
      checkaccount: false,

      payment_type: null,

      pay_by_card_screen: true,
      variable_cost: false,
      pay_reference: "",

      is_dispatched: false,
      is_fixed_price: false,
      is_as_directed: false,
      amount_type: "Fixed",

      payment_done_case: false,

      status: "",
      got_variable_price: false,
      is_locked: false,

      is_manual_booking: null,
      allow_manual_booking: null,
      manually_allowed_check: null,
      phonenumber: null,

      authcode: null,
      decryptedBookingId: null,
      bookingPickupTime: null,
      driverCallsign: null,

      ghostBooking: null,
      admin_allow_third_party: null,
      quoteData: null,
      booking_type: null,

      showCharityDiv: false,
      charityText: "",
      charityDescription: "",
      payForCharity: false,
      charityAmount: 0.0,
      newAmount: 0.0,
      beforeCharityAmount: this.amount,
      companyLogo: null,

      isAndroid: false,
      isIphone: false,
      isWindows: false,
      isMac:false,
      email: null,
      paidPaymentReference: null,
      bookingPaymentAmount: null,
      systemId: null,
      showTracking: false,
    };
  },
  mounted() {
    // document.title = "NUDG Web Application";
    // const favicon = document.getElementById("favicon");
    // if (favicon) {
    //   favicon.href = require("@/assets/images/logo/NudgPay.png");
    // }
    // // const loadingImg = document.getElementById("loadingImg");
    // // console.log(loadingImg);
    // // if (loadingImg) {
    // //   loadingImg.src = require("@/assets/images/logo/NudgPay.png");
    // // }

    //     setTimeout(() => {
    //     const loadingImg = document.getElementById('loadingImg');
    //     if (loadingImg) {
    //       loadingImg.src = require('@/assets/images/logo/track-title-logo.png'); // Ph to the new image
    //     } else {
    //       console.error("Could not find the element with ID 'loadingImg'");
    //     }
    //   }, 5000); // Adjust timeout as needed to allow for DOM load



    // this.detectDevice();
  },

  beforeMount() {
    // document.documentElement.style.overflow = "hidden";
    // this.$vs.loading({ text: "Fetching data......" });

    // _getBooking(this.bid).then(
    //   (res) => {
    //     this.decryptedBookingId = res.data.obj.decrypt_booking_id;
    //     this.current_company = res.data.obj.company_id;
    //     this.systemId = res.data.obj.system_id;
    //     if(this.systemId == 2)
    //       this.showTracking = true;
    //     console.log(this.systemId);
    //     console.log('this.systemId');

    //     this.listen();
    //     this.listenForAnyChange();
    //     this.companyLogo = res.data.obj.company_logo
    //       ? MAIN_DOMAIN + res.data.obj.company_logo
    //       : null;
    //     this.showCharityDiv = res.data.obj.is_charity_enable;
    //     this.booking_type = res.data.obj.booking.bookingType;
    //     this.admin_allow_third_party = res.data.obj.admin_allow_third_party;
    //     this.quoteData = res.data.obj.getquotedata;
    //     this.ghostBooking = res.data.obj.booking;
    //     this.pickup = res.data.obj.pickup;
    //     this.destination = res.data.obj.destination;
    //     this.checkaccount = res.data.obj.checkaccount;
    //     this.paidPaymentReference = res.data.obj.payment;

    //     this.checkezp = res.data.obj.checkezp;
    //     if (this.checkezp) this.payment_done_case = true;

    //     this.is_as_directed = res.data.obj.is_as_directed;
    //     this.is_dispatched = res.data.obj.is_dispatched;
    //     this.is_fixed_price = res.data.obj.is_fixed_price;
    //     this.amount = res.data.obj.price;
    //     this.is_archived = res.data.obj.is_archived;
    //     this.pay_reference = res.data.obj.payment_ref;
    //     this.status = res.data.obj.booking_status;
    //     this.payment_type = res.data.obj.payment_type;

    //     this.booking_found = true;
    //     this.variable_cost = res.data.obj.variable_cost;
    //     this.is_locked = res.data.obj.is_locked;
    //     this.is_manual_booking = res.data.obj.is_manual_booking;
    //     this.allow_manual_booking = res.data.obj.allow_manual_booking;
    //     this.phonenumber = res.data.obj.cust_ref;
    //     this.bookingPaymentAmount = res.data.obj.payment_amount;

    //     if (this.admin_allow_third_party) {
    //       if (
    //         (!this.checkezp &&
    //           this.is_fixed_price &&
    //           this.payment_type == "Card") ||
    //         this.payment_type == "Card" ||
    //         ((this.status == "active" || this.status == "booked") &&
    //           this.is_fixed_price)
    //       ) {
    //         if (!this.is_archived && this.is_locked && !this.is_fixed_price)
    //           this.prepaycall();
    //         else if (!this.is_archived && this.is_fixed_price) this.prepaycall();
    //       }
    //     } else {
    //       if (!this.checkezp && !this.is_archived) this.prepaycall();
    //     }

    //     if (this.is_manual_booking) {
    //       this.manually_allowed_check = this.allow_manual_booking
    //         ? true
    //         : false;
    //     } else {
    //       this.manually_allowed_check = true;
    //     }

    //     this.authcode = res.data.obj.authcode;
    //     this.bookingPickupTime = res.data.obj.booking_pickup_due_time;
    //     this.driverCallsign = res.data.obj.driver_callsign;
    //     this.admin_allow_third_party = res.data.obj.admin_allow_third_party;

    //     this.charityText = res.data.obj.charity
    //       ? res.data.obj.charity.title
    //       : "";
    //     this.charityDescription = res.data.obj.charity
    //       ? res.data.obj.charity.description
    //       : "";

    //     this.$vs.loading.close();
    //   },
    //   (error) => {
    //     this.$vs.loading.close();
    //     this.$vs.notify({
    //       title: "Error",
    //       text: error.response.data.message,
    //       iconPack: "feather",
    //       icon: "icon-cross-circle",
    //       color: "danger",
    //     });
    //   }
    // );



  },
  methods: {
    editButtonClick() {
      this.editBookingPopup = true;
    },
    callUs() {
      window.location.href = 'tel:+441159500500'; // Replace with your phone number
    },
    redirectToDownloadPage() {
      if (this.isAndroid || this.isWindows) {
        const playStoreUrl= 'https://play.google.com/store/apps/details?id=com.dggroup.nudg.user.app&hl=en_US';
        window.location.href = playStoreUrl;
      }
      else if (this.isIphone || this.isMac) {
        const appleStoreUrl= 'https://apps.apple.com/gb/app/nudg-fast-safe-taxi-booking/id1618819793';
        window.location.href = appleStoreUrl;
      }
      else {
        console.log('what type of device is this ??')
      }

    },
    redirectToLiveTrackingPage() {
      this.$router.push({ name: 'LiveTracking' });
    },

    detectDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Detect Android
      if (/android/i.test(userAgent)) {
        console.log('android');

        this.isAndroid = true;
      }

      // Detect iPhone
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        console.log('iphone');
        this.isIphone = true;
      }

      // Windows
      if (/windows phone/i.test(userAgent) || /win/i.test(userAgent)) {
        this.isWindows = true;
        console.log('windows');
      }

       // Mac OS
      if (/macintosh|mac os x/i.test(userAgent)) {
        console.log('mac');

        this.isMac = true;
      }

    },
    payByCard() {
      _asCardPayment({ bid: this.bid }).then(
        (res) => {
          if (res.data.obj.errorCode == "0") {
            if (this.is_fixed_price) {
              // console.log("1");
              this.prepaycall();
            } else {
              if (this.is_locked) {
                // console.log(this.is_locked);
                // console.log("2");
                this.prepaycall();
              }
            }
            this.payment_type = "Card";
          }
        },
        (error) => {
          if (
            error.response.data.errors.errorCode == "3" ||
            error.response.data.errors.errorCode == "4"
          ) {
            this.status = "archived";
            this.is_archived = true;
          }
          console.log(error.response.data.errors.errorCode);
        }
      );
    },
    payCash() {
      _asCashPayment({ bid: this.bid }).then(() => {
        this.payment_type = "Cash";
      });
    },
    listenForAnyChange() {
     window.Echo.channel(`booking.${this.decryptedBookingId}`).listen(
        "GeneralBookingEvent",
        (e) => {
          console.log(e);
          if(e.request_payload.EventType == 'BookingModified') {
            if(e.change_type == 'cost_modified')
              window.location.reload();
          }
        });
    },
    listen() {
      window.Echo.channel(`meter-shout-booking-${this.bid}`).listen(
        "TaxiMeterShout",
        (e) => {
          if (this.admin_allow_third_party) {
            if (e.message == "vehicleDispatchEvent") {
              this.is_dispatched = true;
              this.status = "pickedup";
            } else if (e.message == "variableBooking") {
              this.is_dispatched = true;
              this.status = "pickedup";
              this.amount = null;
              this.amount_type = "Variable";
            } else {
              this.amount_type = "Variable";
              this.amount = e.data;
            }
            // this.is_locked = true;
            if (!this.is_locked && this.payment_type == "Card") {
              this.is_locked = true;
              this.prepaycall();
            }
          } else {
            // console.log('ok')
          }
        }
      );
    },
    payNow() {
      this.$refs.pay.submit();
    },
    prepaycall(charity = false) {
      if (this.admin_allow_third_party) {
        if (this.is_fixed_price) this.amount = this.amount;
        else this.amount = this.amount ? this.amount : 0.0;
      } else {
        if (!this.is_manual_booking) {
          // if manual booking always get its price
          // if (this.booking_type == "ASAP") {
          // run quote if booking is ASAP as per ubaids command on 19-09-22
          this.amount = this.quoteData["outward"]["price"];
          // }
        }
      }
      if (charity) {
        this.amount = this.newAmount;
      }
      const data = {
        bid: this.bid,
        price: this.amount,
        charityAmount: Number(this.charityAmount),
        actualBookingPrice: this.amount - this.charityAmount,
        pickup: this.pickup,
        destination: this.destination,
        cust_reference: this.phonenumber
          ? this.phonenumber
          : Math.random().toString(36).substring(2, 7), //set to mobile number
        pay_reference: this.pay_reference,
      };
      axios.post(`booking/pay`, data).then(
        (resp) => {
          this.postUrl = resp.data.postUrl;
          this.reference = resp.data.reference;
        },
        (error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: error.response.data.responseMessage,
            text: error.response.data.errors.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        }
      );
    },
    calculateAmountWithCharity() {
      var newAmount;
      if (Number.isInteger(this.amount)) newAmount = this.amount + 1;
      else newAmount = Math.ceil(this.amount);
      this.charityAmount = parseFloat(newAmount - this.amount).toFixed(2);
      this.newAmount = newAmount;
      return parseFloat(newAmount - this.amount).toFixed(2);
    },

    openCharityDescription() {
      if (!this.payForCharity) this.calculateAmountWithCharity();
      this.charityDescriptionPopup = true;
    },
    getReciept() {
      if (!this.email) alert("Please enter valid email to get receipt");
      _getReceipt({ email: this.email }, this.paidPaymentReference).then(
        (res) => {
          alert('email has been sent to your given address');
          this.email ='';
          console.log(res);
        }
      );
    },
  },
};
</script>


<style scoped>
@import "./../../assets/smspay/css/newDesign.css";

</style>
